import { cn as e } from "../shared/utils.js";
import { Radio as t } from "./primitive/index.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/radio/radio-button.tsx
function i({ className: i, description: a, descriptionProps: o, indicatorProps: s, label: c, labelProps: l, rootProps: u, value: d }) {
	let f = !!c, p = !!a;
	return /* @__PURE__ */ r("label", {
		className: e("text-text-primary inline-flex items-start gap-2 text-base font-normal", u?.disabled ? "text-text-disabled cursor-not-allowed" : "cursor-pointer", i),
		children: [/* @__PURE__ */ n(t.Root, {
			...u,
			className: u?.className,
			value: d,
			children: /* @__PURE__ */ n(t.Indicator, {
				...s,
				className: s?.className
			})
		}), (f || p) && /* @__PURE__ */ r("span", {
			className: "flex min-w-0 flex-col gap-1",
			children: [f && /* @__PURE__ */ n("span", {
				...l,
				className: e("leading-5", l?.className),
				children: c
			}), p && /* @__PURE__ */ n("span", {
				...o,
				className: e("min-w-0 text-sm/5", u?.disabled ? "text-text-disabled" : "text-text-tertiary", o?.className),
				children: a
			})]
		})]
	});
}
//#endregion
export { i as RadioButton };
